import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { PolicyBelongToAnotherScreenComponent } from '../../../../../screens/signup-process/policy-belong-to-another-screen/policy-belong-to-another-screen.component';
import { PolicyErrorSvgComponent } from '../../../../../../modules/mapfre-design-library/src/lib/svg/policy-error-svg/policy-error-svg.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { User, AlertService } from '@mapfre-design-library/src/public_api';
import { AuthenticationService } from '../../../../../../_services/_iam/authentication-service.service';
import { Router , RouterModule } from '@angular/router';
import { UserService } from '../../../../../../_services/user.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, PolicyErrorSvgComponent, PolicyBelongToAnotherScreenComponent, MapfreButtonComponent],
  selector: 'app-validate-policy-rights',
  templateUrl: './validate-policy-rights.component.html',
})
export class ValidatePolicyRightsComponent {
  @Input() userData: User;
  policyDate: string;
  policyDetails: any = {};
  policyNumber: string;
  user: any = {};

  constructor(
    private alertService: AlertService,
    private authService: AuthenticationService,
    public router: Router,
    private userService: UserService
  ) {}

  confirmPolicy(): void {
    this.authService.confirmPolicyAndAccount(this.userService).subscribe(
      () => {
        this.alertService.success('Policy added successfully');
        this.router.navigate(['/my-insurance']);
      },
      () => {
        this.alertService.error('There was an issue');
      }
    );
  }

  createUserObject(formValue): void {
    this.policyDetails = [
      { policynumber: { policyNumber: formValue.editPolicyNumber } },
    ];

    this.userService.$user.subscribe((user) => {
      this.user = {
        firstName: user.firstName,
        middleName: user.middleName,
        lastName: user.lastName,
        email: { address: user.email.address },
        policyDetails: this.policyDetails,
      };
    });
    this.userService.updateUser(this.user);
  }

}
